import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import productApiV2 from '../../../lib/api/product/ProductApiV2';
import { ProductCustomFieldsResponseDto } from '../../../types/api/product-custom-fields';
import { CustomAttributePayload } from '../../../types/product/customAttribute';

type ProductCustomFieldUpdateResponse = ProductCustomFieldsResponseDto;

type ProductCustomFieldUpdateVariables = {
  productId: number;
  payload: CustomAttributePayload;
};

export const useUpdateProductCustomFields = (
  options?: UseMutationOptions<ProductCustomFieldUpdateResponse, unknown, ProductCustomFieldUpdateVariables>,
) => {
  return useMutation<ProductCustomFieldUpdateResponse, unknown, ProductCustomFieldUpdateVariables>(
    ({ productId, payload }) => productApiV2.updateProductCustomFields(productId, payload),
    options,
  );
};

export default useUpdateProductCustomFields;
